import { render, staticRenderFns } from "./InfoFooters.vue?vue&type=template&id=30e5a205&scoped=true"
import script from "./InfoFooters.vue?vue&type=script&lang=js"
export * from "./InfoFooters.vue?vue&type=script&lang=js"
import style0 from "./InfoFooters.vue?vue&type=style&index=0&id=30e5a205&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e5a205",
  null
  
)

export default component.exports